import type { ContextViewStep } from "../../context/useContextViewState";

export interface WizardStepDisplayConfig {
  message: string;
  ctaLabel?: string;
  loading?: boolean;
  loaderTitle?: string;
  loaderSubtitle?: string;
}

export const WIZARD_STEP_DISPLAY: Record<ContextViewStep, WizardStepDisplayConfig> = {
  setup: {
    message: "Add sources or generate suggestions to continue building this context.",
    ctaLabel: "Continue setup",
  },
  "page-picker": {
    message: "Choose which pages from your website to include.",
    ctaLabel: "Choose pages",
  },
  analysing: {
    message: "Generating questions from your sources…",
    loading: true,
    loaderTitle: "Generating questions…",
    loaderSubtitle: "Reading your sources and preparing a few clarifying questions.",
  },
  questions: {
    message: "Answer a few questions to finish your context.",
    ctaLabel: "Answer questions",
  },
  building: {
    message: "Generating your context…",
    loading: true,
    loaderTitle: "Generating your context…",
    loaderSubtitle: "Turning your sources and answers into a structured context document.",
  },
  suggesting: {
    message: "Generating strategic suggestions…",
    loading: true,
    loaderTitle: "Generating strategic suggestions…",
    loaderSubtitle: "AI is reading your accepted context and proposing forward-looking statements.",
  },
  "context-view": {
    message: "Your updated context is ready to review.",
    ctaLabel: "Review context",
  },
};

export const ANALYSING_LOADER_VARIANTS = {
  questions: WIZARD_STEP_DISPLAY.analysing,
  context: WIZARD_STEP_DISPLAY.building,
} as const;
